import React, { useEffect, useMemo, useState } from "react";
import ct from "countries-and-timezones";
import "./TimezoneClock.css";

const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

export default function TimezoneClock() {
  const [time, setTime] = useState(new Date());
  const [country, setCountry] = useState(localStorage.getItem("country") || "");
  const [timezone, setTimezone] = useState(
    localStorage.getItem("timezone") || browserTimezone
  );

  // Tick every second
  useEffect(() => {
    const interval = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(interval);
  }, []);

  // Countries A–Z
  const countries = useMemo(() => {
    return Object.values(ct.getAllCountries()).sort((a, b) =>
      a.name.localeCompare(b.name)
    );
  }, []);


  useEffect(() => {
    if (!country) return;

    const countryData = ct.getCountry(country);
    const tz = countryData?.timezones?.[0];

    if (tz) {
      setTimezone(tz);
      localStorage.setItem("timezone", tz);
    }
    localStorage.setItem("country", country);
  }, [country]);

  const formattedTime = new Intl.DateTimeFormat("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    timeZone: timezone,
  }).format(time);

  return (
    <div className="tzc-container">
      <div className="tzc-clock">{formattedTime}</div>
      <div className="tzc-tz">{timezone}</div>

      <select
        className="tzc-select"
        value={country}
        onChange={(e) => setCountry(e.target.value)}
      >
        <option value="">Select country</option>
        {countries.map((c) => (
          <option key={c.id} value={c.id}>
            {c.name}
          </option>
        ))}
      </select>
    </div>
  );
}
